import SectionHub from '@/components/docs/SectionHub';

export default function Docs03FundamentalsInsidersHub() {
  return <SectionHub sectionPath="03-fundamentals/insiders" />;
}
